import { FlexColumn, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { ASSET_TYPE } from '../../constants/asset';
import { useStyles } from '../../hooks/useStyles';
import { Asset } from '../../types/asset';
import { ParagraphSmall } from 'baseui/typography';

type Props = Readonly<{
  asset: Asset;
  fullData?: boolean;
  withDevices?: boolean;
}>;

export function AssetDataResume({ asset, fullData = true, withDevices = true }: Props) {
  const { classes, theme } = useStyles();
  const { formatDateFromTs } = useMoment();

  return (
    <FlexColumn
      classNames={classes.flexFill}
      gap={theme.sizing.scale300}
    >
      {withDevices && asset.device && (
        <LabeledData
          label="Dispositivo:"
          content={asset.device.ident}
        />
      )}
      {withDevices && !!asset.secondaries?.length && (
        <LabeledData
          label="Dispositivos Secundarios:"
          content={
            <ParagraphSmall
              margin={0}
              color={theme.colors.contentSecondary}
            >
              {asset.secondaries.map((secondarie) => secondarie.ident).join(', ')}
            </ParagraphSmall>
          }
        />
      )}
      {asset.assetType && (
        <LabeledData
          label="Tipo:"
          content={ASSET_TYPE[asset.assetType] ?? asset.assetType}
        />
      )}
      {asset.client && (
        <LabeledData
          label="Cliente:"
          content={asset.client.name}
        />
      )}
      {asset.subClient && (
        <LabeledData
          label="Subcliente:"
          content={asset.subClient.name}
        />
      )}
      {fullData && (
        <>
          <LabeledData
            label="En trayecto:"
            content={asset?.inJourney ? 'Si' : 'No'}
          />
          {asset.journeyId && asset.inJourney && (
            <LabeledData
              label="Trayecto (ID):"
              content={asset.journeyId}
            />
          )}
        </>
      )}
      <LabeledData
        label="Eliminado:"
        content={asset?.deleted ? 'Si' : 'No'}
      />
      <LabeledData
        label="Seguimiento:"
        content={asset?.monitoring ? 'Si' : 'No'}
      />
      {asset?.insuranceNumber && (
        <LabeledData
          label="Póliza:"
          content={asset?.insuranceNumber}
        />
      )}
      {asset?.insuranceStartDate && (
        <LabeledData
          label="Inicio vigencia:"
          content={formatDateFromTs(asset?.insuranceStartDate)}
        />
      )}
      {asset?.insuranceEndDate && (
        <LabeledData
          label="Fin vigencia:"
          content={formatDateFromTs(asset?.insuranceEndDate)}
        />
      )}
    </FlexColumn>
  );
}
